// extracted by mini-css-extract-plugin
module.exports = {"container":"_e7c4572","expandButton":"_b263a7c","arrow":"_16a2803","active":"_ba2ce34","collapseContainer":"_d3eddcd","icon":"_c229d9a","blueFill":"_00f71b9"};